module.exports = __webpack_public_path__ + "static/iFood-37812fcceed71ee6fa59a5474cc6e3af.jpg";